import * as numeral from 'numeral';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DatatableV3Component } from '../datatable-v3/datatable-v3.component';

@Component({
	selector: 'app-geofence-apps-v3',
	styleUrls: ['./geofence-apps-v3.component.css'],
	templateUrl: './geofence-apps-v3.component.html'
})
export class GeofenceAppsV3Component extends DatatableV3Component implements OnInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() datatableconfig;
	@Input() isTotalCalc;
	@Input() downloadconfig: string;

	public geofenceAppData: any[];
	public downloadConfiguration: DownloadConfig;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.geofenceAppData = [];
		super.ngOnInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	requestData(): void {
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			this.dataTableObj.data = [];
			this.geofenceAppData = [];
			if (res.success) {
				this.hasData = true;
				this.processResponseData(res.data);
			} else {
				this.hasData = false;
				this.geofenceAppData = [];
			}
		});
	}

	generateDateTableConfiguration(responseData: any): void {
		let appNameCnt = 0;
		this.dataTableObj.data = this.generateResponseDataFromConfig(responseData);
		super.generateDateTableConfiguration(responseData);
		for (let i = 0; i < this.dataTableObj.data.length; i++) {
			appNameCnt++;
			const formattedAppName = 'App ' + appNameCnt;
			const obj = this.dataTableObj.data[i];
			obj.appname = responseData[i].appname;
			obj.formattedAppName = formattedAppName;
			this.geofenceAppData.push(obj);
		}

		this.processDataForProgressBar(this.dataTableObj.data);
	}
	downloadDataInCSV(event: any): void {
		event.preventDefault();
		this.analyticsService.downloadCSV(this.downloadConfiguration.csvQueryKey, this.downloadConfiguration.fileName);
	}
}
